import * as React from 'react';
import { memo } from 'react';
import { LucideIcon } from 'lucide-react';

import styled from 'styled-components';

import { getFontFamily } from 'services/FontService';
import { Icon, IconProps } from 'atoms';

export interface ISettingsTab {
  active?: boolean;
  icon: IconProps;
  /** Optional lucide icon; when set it replaces the custom `Icon` atom. */
  lucideIcon?: LucideIcon;
  /** Counter above the name; omitted for a tab that counts nothing. */
  value?: number;
  name: string;
}

export const SettingsTab = memo(
  ({ active, icon, lucideIcon: LucideIco, value, name }: ISettingsTab) => (
    <StyledSettingsTab active={active} icon={icon} value={value} name={name}>
      <IconWrapper>
        {LucideIco ? (
          <LucideIco
            size={28}
            strokeWidth={2}
            color={active ? 'var(--k-fg-ffffff)' : 'var(--k-fg-0d53fc)'}
          />
        ) : (
          <Icon
            name={icon.name}
            height={icon.height}
            width={icon.width}
            color={active ? 'var(--k-fg-ffffff)' : 'var(--k-fg-0d53fc)'}
          />
        )}
      </IconWrapper>
      <Counter>{value ?? null}</Counter>
      <Name>{name}</Name>
    </StyledSettingsTab>
  ),
);

const IconWrapper = styled.div``;

const Counter = styled.span`
  margin-top: auto;
  font-family: ${getFontFamily('semibold')};
  font-size: 36px;
  line-height: 24px;
`;

const Name = styled.span`
  margin: 8px 0;
  font-family: ${getFontFamily('bold')};
  font-size: 14px;
  line-height: 24px;
`;

const StyledSettingsTab = styled.div<ISettingsTab>`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  border-width: 1px;
  border-style: solid;
  border-radius: 8px;
  padding: 23px;
  ${({ active }) => `
    background-color: ${active ? 'var(--k-bg-0d53fc)' : 'var(--k-bg-ffffff)'};
    border-color: ${
      active ? 'var(--k-border-0d53fc)' : 'var(--k-border-ebeff2)'
    };

    & > ${Counter} {
      color: ${active ? 'var(--k-fg-ffffff)' : 'var(--k-fg-0d53fc)'};
    }
  
    & > ${Name} {
      color: ${active ? 'var(--k-fg-ffffff)' : 'var(--k-fg-263446)'};
    }
  `};
`;
